<template>
  <DragTable
    class="hiit-table"
    v-model="hiitWorkout.circuits"
    group="circuits"
    handle=".circuit-td"
    placeholder="Sin circuitos"
    :drag-content-classes="{'drag-content-width' : true }"
    ref="table"
  >
    <template v-slot:header>
      <div class="flex-th table-title">
        <div class="circuit-btnbar-group left-group">
          <span> Dificultad: </span>
          <b-form-select id="input-diet"
            v-model="hiitDifficulty"
            :options="hiitOptions"
            size="sm"
          />
        </div>
        {{ title }}
        <div class="circuit-btnbar-group right-group">
          <b-button :id="routine + 'hiit-button'" @click="addCircuit" variant="light">+</b-button>
          <b-tooltip :target="routine + 'hiit-button'" triggers="hover" placement="left">
            Agregar circuito
          </b-tooltip>
        </div>
      </div>
      <div class="flex-trow flex-trow-header">
        <div class="flex-th circuit-th">Circuito</div>
        <div class="flex-th name-th">Ejercicio</div>
        <div class="flex-th details-th">Tiempo de ejecución</div>
        <div class="flex-th details-th">Descanso</div>
        <div class="flex-th details-th">Series</div>
      </div>
    </template>
    <template v-slot:draggable>
      <div
        v-for="(circuit, circuitIndex) in dataCircuits.circuits"
        :key="circuit.id"
        class="flex-trow drag-row"
        :style="getRowStyle(circuitIndex)"
      >
        <div class="remove-circuit" @click="removeCircuit(circuitIndex)">
          <IconCross />
        </div>
        <div
          class="flex-td circuit-td"
          @contextmenu.prevent.stop="openColorMenu($event, circuitIndex)"
        >Circuito {{ circuitIndex + 1 }}</div>
        <div 
          class="flex-td nested-td"
        >
          <DragTable
            class="hiit-ex-table"
            v-model="circuit.exercises"
            group="routine"
            handle=".name-nested-td"
            placeholder="Sin ejercicios"
            ref="table"
          >
            <template v-slot:draggable>
              <div v-for="(exercise, exerciseIndex) in circuit.exercises"
                :key="exercise.id"
                class="nested-row"
              >
                <div class="remove-exercise" @click="removeExercise(circuitIndex, exerciseIndex)">
                  <IconCross />
                </div>
                <div class="flex-td name-nested-td">
                  {{ exercise.type.name }}
                </div>
                <div class="flex-td details-nested-td editable-cell num-cell with-unit disabled">
                  <EditableCellInput v-model="exercise.work_time" inputType="number"/>
                  <EditableCellSelect :disabled="true" value="seg" />
                </div>
              </div>
            </template>
          </DragTable>
        </div>
        <div class="flex-td details-td editable-cell num-cell with-unit disabled">
          <EditableCellInput v-model="circuit.rest_time" inputType="number"/>
          <EditableCellSelect :disabled="true" value="seg" />
        </div>
      </div>
    </template>
    <template v-slot:right-column>
      <div class="long-column editable-cell num-cell">
        <EditableCellInput v-model="dataCircuits.sets" inputType="number"/>
      </div>
    </template>
  </DragTable>
</template>

<script>
import { keyMixin } from "../../mixins/keyMixin";
import { getCorrectedColorName, getColorContrast } from "../../utils";
import DragTable from "./base/DragTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from "../EditableCellSelect";
import IconCross from "../icon/IconCross";
import cloneDeep from "lodash/cloneDeep"

export default {
  name: "HiitTable",
  components: { IconCross, DragTable, EditableCellInput, EditableCellSelect },
  model: {
    prop: "hiitWorkout",
    event: "change"
  },
  mixins: [keyMixin],
  props: {
    hiitWorkout: {
      type: Object,
      default: function() {
        return {
          circuits: [],
          sets: 4
        };
      }
    },
    title: {
      type: String,
      default: "Cardio HIIT"
    },
    routine: {
      type: String
    },
    hiitPresets: {
      type: Array,
      default: function(){
        return {}
      }
    },
    hiitOptions: {
      type: Array,
      default: function(){
        return []
      }
    }
  },
  data: function() {
    return {
      dataCircuits: this.hiitWorkout,
      circuits: this.hiitWorkout.circuits.length,
      hiitDifficulty: undefined
    };
  },
  methods: {
    removeCircuit: function(index) {
      this.dataCircuits.circuits.splice(index, 1);
    },
    removeExercise: function(circuit, index) {
      this.dataCircuits.circuits[circuit].exercises.splice(index, 1);
    },
    addCircuit: function() {
      this.circuits += 1
      this.dataCircuits.circuits.push(
        {
          id: this.random_key(),
          color: '#ffffff',
          exercises: [],
          order: this.circuits,
          rest_time: 60,
        }
      )
    },
    getRowStyle: function(rowIndex) {
      const style = {};
      const rowColor = this.hiitWorkout.circuits[rowIndex].color;
      style.backgroundColor = getCorrectedColorName(rowColor);
      style.color = getColorContrast(rowColor) < 0 ? "#333" : "#FFF";
      return style;
    },
    openColorMenu(event, rowIndex) {
      this.$store.commit("contextMenu/setOpen", true);
      this.$store.commit("contextMenu/setPosition", {
        x: event.pageX,
        y: event.pageY
      });
      this.$store.commit("contextMenu/setTarget", this.hiitWorkout.circuits[rowIndex]);
    }
  },
  watch: {
    dataCircuits: { 
      handler: function(val) {
        this.$emit("change", val);
      },
      deep: true,
    },
    hiitDifficulty: {
      handler: function(val) {
        let presetIndex = this.hiitPresets.findIndex(workout => workout.level === val)
        this.dataCircuits.circuits.splice(0, this.dataCircuits.circuits.length)
        if (presetIndex > -1) {
          let cloned = cloneDeep(this.hiitPresets[presetIndex].circuits)
          this.dataCircuits.circuits.push(...cloned)
          this.dataCircuits.sets = this.hiitPresets[presetIndex].sets
        } else {
          this.dataCircuits.sets = 0
          this.$toasted.error("No se pudieron cargar los circuitos")
        } 
      }
    }
  }
};
</script>

<style scoped lang="scss">
$hiit-table-base-color: #117a8b;
$hiit-table-title-bg-color: $hiit-table-base-color;
$hiit-table-title-color: $white;
$hiit-table-header-bg-color: rgba($hiit-table-base-color, 0.1);
$hiit-table-header-color: darken($hiit-table-base-color, 10);

.hiit-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;

  & .long-column {
    display: block;
    flex: 1 0 9rem;
    width: 9rem;
    background-color: #8EAADB;
    border: 1px solid rgba(33, 37, 41, 0.1);
  }
}

.hiit-ex-table {
  overflow-x: auto;
  width: 100%;
  flex-direction: column;
}

.flex-th.table-title {
  background-color: $hiit-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
  padding: 0.5rem;
}

.flex-th {
  background-color: $hiit-table-header-bg-color;
  color: $hiit-table-header-color;
  padding: 0.25rem;
}

.circuit-td,
.circuit-th {
  justify-content: flex-start;
  text-align: center;
  padding-left: 40px;
  flex: 1 0 9rem;
  min-width: 9rem;
}

.name-td,
.name-th {
  justify-content: flex-start;
  text-align: center;
  padding-left: 40px;
  flex: 1 0 18rem;
  min-width: 18rem;
}

.details-td,
.details-th {
  justify-content: center;
  text-align: center;
  flex: 1 0 9rem;
  min-width: 9rem;
}
.nested-td {
  flex-flow: column wrap;
  justify-content: flex-start;
  padding: 0px;
  flex: 2 0 27rem;
  min-width: 27rem;

  & .nested-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    width: 100%;
  }

  & .name-nested-td {
    flex: 1 0 18rem;
    padding: 8px 16px;
    padding-left: 40px;
    min-width: 10rem;
    border-left: 0px;
  }

  & .details-nested-td {
    flex: 1 0 9.1rem;
    padding: 0px;
    min-width: 6rem;
    border-right: 0px;
  }
}

.flex-td.name-nested-td {
  justify-content: flex-start;
  text-align: left;
}

.circuit-td,
.name-nested-td {
  cursor: move;
}

.drag-row.flex-trow,
.nested-row {
  position: relative;
  min-height: $routine-row-min-height;
  min-width: fit-content;
}

.drag-chosen .flex-td:not(.name-td) {
  opacity: 0.25;
}

.flex-trow .remove-circuit,
.nested-row .remove-exercise {
  display: none;
  position: absolute;
  margin: -0.5px;
  height: 100%;
  align-items: center;
  width: 2rem;
  justify-content: center;
  color: inherit;

  & svg {
    width: 1rem;
    margin-top: 0.1rem;
    opacity: 0.5;
  }

  &:after {
    content: "";
    display: block;
    background-color: currentColor;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;
  }
}

.flex-trow:hover .remove-circuit,
.nested-row:hover .remove-exercise {
  display: flex;
  cursor: pointer;
}

.num-cell input {
  padding: 0;
}

.editable-cell {
  & input,
  & textarea,
  & input::placeholder,
  & textarea::placeholder {
    color: inherit;
  }
}

.with-unit {
  position: relative;

  & input {
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    opacity: 0.5;
    color: inherit;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      opacity: 1;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active,
    &:focus {
      opacity: 1;
      background-color: $active-background-color;
    }
  }
}

.circuit-btnbar-group {
  position: absolute;
  display: flex;
  align-items: center;

  &.left-group {
    left: 0.5rem;
  }

  &.right-group {
    right: 0.5rem;
  }

  & span {
    font-weight: normal;
    font-size: $font-size-sm;
    margin: 0 0.3rem 0;
  }

  & button {
    margin: 0 map_get($spacers, 1);
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.2rem 0.2rem 0.4rem;
    line-height: 0;
    font-weight: bold;
  }
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss">
.hiit-table {
  & > .flex-tcol {
    flex-basis: 100%;
  }

  & .drag-content .transition-group {
    display: flex;
    flex-direction: column;
    width: auto;
  }
}

.hiit-table {
  & .drag-content-width {
    flex: 5 0 45rem;
  }
}
</style>